import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { jsx } from "@emotion/core";
export function getInnerText(node) {
  if (node === null || typeof node === "boolean") {
    return "";
  }

  if (typeof node === "number") {
    return node.toString();
  }

  if (typeof node === "string") {
    return node;
  }

  if (Array.isArray(node)) {
    return node.reduce(function (previous, current) {
      return previous + getInnerText(current);
    }, "");
  }

  var element = node;

  if (element.props && element.props.children) {
    return getInnerText(element.props.children);
  }

  return "";
}
export function applySearch(items, searchQuery) {
  var filteredItems = items.filter(function (item) {
    if (!searchQuery || !item.content) {
      return true;
    }

    var searchText = searchQuery.toLowerCase().replace(/ /g, "");
    var itemText = getInnerText(item.content).toLowerCase().replace(/\s/g, "");
    return itemText.includes(searchText);
  }).sort(function (a, b) {
    if (!searchQuery) {
      return 0;
    }

    var searchText = searchQuery.toLowerCase().replace(/ /g, "");
    var aText = getInnerText(a.content).toLowerCase().replace(/\s/g, "");
    var bText = getInnerText(b.content).toLowerCase().replace(/\s/g, "");
    var aStartsWithSearch = aText.startsWith(searchText);
    var bStartsWithSearch = bText.startsWith(searchText);

    if (aStartsWithSearch && bStartsWithSearch) {
      return aText.localeCompare(bText);
    } else if (aStartsWithSearch) {
      return -1;
    } else if (bStartsWithSearch) {
      return 1;
    } else {
      return aText.localeCompare(bText);
    }
  });
  return filteredItems;
} // Similar to clone elements, but using emotions jsx() function
// to clone as this let's us use the css prop

export function cloneElementWithCss(children, styles, props) {
  return jsx(children.type, _objectSpread(_objectSpread(_objectSpread({
    key: children.key
  }, children.props), props), {}, {
    css: styles
  }));
}

function isReactFragment(variableToInspect) {
  if (variableToInspect === null || variableToInspect === undefined) {
    return false;
  }

  return variableToInspect.type === React.Fragment;
}

export function unwrapFragment(node) {
  var element = node;

  if (element && isReactFragment(element)) {
    return element.props.children;
  }

  return [node];
}